export const layouts = {
    gridLayout: 'gridLayout',
    horizontalLayout: 'horizontalLayout',
    verticalLayout: 'verticalLayout',
};
export const sizes = {
    medium: 'medium',
    small: 'small',
};
